import { createPromiseAction } from 'redux-saga-promise-actions';
import { TripsOldPayload, TripsOldResponse } from 'store/types/reports';

export const getTripsOld = createPromiseAction('GET_TRIPSOLD', 'GET_TRIPSOLD_SUCCEEDED', 'GET_TRIPSOLD_FAILURE')<
  TripsOldPayload,
  TripsOldResponse,
  undefined
>();
